import { atom } from 'jotai'
import { User } from '../../shared/interfaces/User'

const userAtom = atom<User | null>(null)

export { userAtom }
